import { Anlage } from "./anlage"
import { Gesamtsummen } from "./gesamtsummen"
import { Lieferinformation } from "./lieferinformation"
import { Position } from "./position"
import { SteuerDetails } from "./rechnung/rechnungsebene/steuerdetails"
import { ZuAbschlag } from "./rechnung/rechnungsebene/zuAbschlag"
import { Rechnungsdaten } from "./rechnungsdaten"
import { Rechnungsempfaenger } from "./rechnungsempfaenger"
import { Rechnungssteller } from "./rechnungssteller"
import { Rechnungstext } from "./rechnungstext"
import { Rechnungsverlauf } from "./rechnungsverlauf"
import { Steuervertreter } from "./steuervertreter"
import { Zahlungsdaten } from "./zahlungsdaten"

export class Rechnung {
    rechnungsdaten = new Rechnungsdaten()
    rechnungstexte: Rechnungstext[] = []
    rechnungssteller = new Rechnungssteller()
    rechnungsempfaenger = new Rechnungsempfaenger()
    zahlungsdaten = new Zahlungsdaten()
    positionen: Position[] = [this.newPosition()]
    anlagen: Anlage[] = []
    lieferinformation = new Lieferinformation()
    gesamtsummen = new Gesamtsummen()
    steuerDetails: SteuerDetails[] = []
    rechnungAbschlaege: ZuAbschlag[] = []
    rechnungZuschlaege: ZuAbschlag[] = []
    steuervertreter: Steuervertreter = new Steuervertreter()
    rechnungsverlauf: Rechnungsverlauf[] = [new Rechnungsverlauf()]
    steuerberechnung = ""

    private newPosition() {
        const pos = new Position()
        pos.positionsnummer = "1"
        return pos
    }

    removePosition(index: number) {
        this.positionen.splice(index, 1)
    }

    removeAnlage(index: number) {
        this.anlagen.splice(index, 1)
    }

    removeRechnungstext(index: number) {
        this.rechnungstexte.splice(index, 1)
    }

    removeSteuerDetail(index: number) {
        this.steuerDetails.splice(index, 1)
    }

    toJSON() {
        return {
            rechnungsdaten: this.rechnungsdaten,
            rechnungstexte: this.rechnungstexte.filter((rt) => rt.notEmpty),
            rechnungssteller: this.rechnungssteller,
            rechnungsempfaenger: this.rechnungsempfaenger,
            lieferinformation: this.lieferinformation,
            zahlungsdaten: this.zahlungsdaten,
            steuerDetails: this.steuerDetails.filter((sd) => sd.notEmpty),
            positionen: this.positionen,
            gesamtsummen: this.gesamtsummen,
            anlagen: this.anlagen.filter((a) => a.notEmpty).length > 0 ? this.anlagen : undefined,
            rechnungAbschlaege: this.rechnungAbschlaege.length > 0 ? this.rechnungAbschlaege : undefined,
            rechnungZuschlaege: this.rechnungZuschlaege.length > 0 ? this.rechnungZuschlaege : undefined,
            steuervertreter: this.steuervertreter.notEmpty ? this.steuervertreter : null,
            rechnungsverlauf: this.rechnungsverlauf.filter((r) => r.rechnungsnummer.trim().length > 0).length > 0 ? this.rechnungsverlauf : undefined,
        }
    }
}
